import React from 'react'

const Login = () => {
  return (
    <div>
      Look At the Top Right Corner To Login, after Login Click <a href="https://ieeedkte.web.app/admin">here</a>
    </div>
  )
}

export default Login
